import Home from "./Home";
import { EXECUTIVE_CV_SERVICE } from "../lib/services";

export default function ExecutiveCvPage() {
  return <Home service={EXECUTIVE_CV_SERVICE} />;
}
